import { useEffect, useState } from "react";
import { getUser } from "@/lib/api";
import { Lock } from "@phosphor-icons/react";
import logo from "@/assets/logo-popcopos.webp";

/**
 * Home / Placeholder para estações restritas.
 *
 * Modos:
 *  - "home": exibido em "/" quando o usuário não tem perm 'dashboard'
 *    (logo + nome da estação + relógio).
 *  - "denied": exibido quando a estação tenta abrir uma página sem
 *    permissão — mesmo layout, com uma faixa vermelha
 *    "VOCÊ NÃO TEM PERMISSÃO PARA ACESSAR ESTA ÁREA".
 */
export default function StationHome({ mode = "home" }) {
  const user = getUser();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  const isDenied = mode === "denied";

  return (
    <div
      className="min-h-[calc(100vh-0px)] flex flex-col items-center justify-center bg-white p-8"
      data-testid="station-home"
      data-mode={mode}
    >
      {isDenied && (
        <div
          className="mb-8 flex items-center gap-3 border-2 border-[#E60000] bg-red-50 px-5 py-3"
          data-testid="station-home-denied"
        >
          <Lock size={22} weight="fill" color="#E60000" />
          <div>
            <div className="overline text-[#E60000]" style={{ fontSize: 10 }}>ACESSO NEGADO</div>
            <div className="font-head text-lg font-black text-[#E60000] tracking-tight uppercase">
              Você não tem permissão para acessar esta área
            </div>
          </div>
        </div>
      )}

      <img
        src={logo}
        alt="POP COPOS"
        className={`w-[min(60vw,420px)] h-auto select-none ${isDenied ? "opacity-70" : ""}`}
        draggable={false}
        data-testid="station-home-logo"
      />

      {user?.is_station && (
        <div className="mt-10 text-center">
          <div className="overline text-zinc-400" style={{ fontSize: 11 }}>ESTAÇÃO</div>
          <div className="font-head text-2xl font-bold mt-1" data-testid="station-home-name">
            {user?.name || "—"}
          </div>
          {user?.sector && (
            <div className="text-xs text-zinc-500 mt-1 font-mono">{user.sector}</div>
          )}
        </div>
      )}

      <div className="mt-10 font-mono text-xs text-zinc-400" data-testid="station-home-clock">
        {now.toLocaleString("pt-BR", {
          weekday: "long",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}
      </div>
    </div>
  );
}
